(function () {
  var SELECTOR = '[data-shipping-quote-intake]';
  var existingRuntime = window.GhidiniShippingQuoteIntake;
  if (existingRuntime && typeof existingRuntime.initScope === 'function') {
    existingRuntime.initScope(document);
    return;
  }

  var runtime = {
    containerStates: new WeakMap(),
    sectionLoadBound: false,
    turnstile: {
      callbacks: [],
      failedScripts: new WeakSet(),
      listening: false,
      script: null
    }
  };
  window.GhidiniShippingQuoteIntake = runtime;
  var CUSTOM_ANALYTICS_EVENT = 'hdt:custom-analytics';
  var REQUEST_STORAGE_KEY = 'ghidiniShippingQuoteRequestId';
  var REQUEST_ID_PATTERN = /^sqr-[a-z0-9-]{16,36}$/;
  var TURNSTILE_ERROR_CODES = {
    turnstile_unavailable: true,
    turnstile_failed: true,
    turnstile_action_mismatch: true,
    turnstile_hostname_mismatch: true
  };

  var publishAnalyticsEvent = function (type, params) {
    if (!type) return;
    document.dispatchEvent(new CustomEvent(CUSTOM_ANALYTICS_EVENT, {
      detail: {
        type: type,
        params: params || {}
      }
    }));
  };

  var analyticsErrorCode = function (error) {
    var code = error && error.body ? String(error.body.error || '') : '';
    return /^[a-z0-9_]{1,64}$/.test(code) ? code : 'unknown';
  };

  var analyticsCartItemCount = function (cart) {
    if (!Array.isArray(cart)) return 0;

    return cart.reduce(function (total, item) {
      var quantity = Number(item && item.quantity) || 0;
      return total + Math.max(0, quantity);
    }, 0);
  };
  var REGION_CODES = 'AF,AX,AL,DZ,AD,AO,AI,AG,AR,AM,AW,AU,AT,AZ,BS,BH,BD,BB,BY,BE,BZ,BJ,BM,BT,BO,BA,BW,BR,IO,BN,BG,BF,BI,CV,KH,CM,CA,KY,CF,TD,CL,CN,CX,CC,CO,KM,CG,CD,CK,CR,HR,CW,CY,CZ,CI,DK,DJ,DM,DO,EC,EG,SV,GQ,ER,EE,SZ,ET,FK,FO,FJ,FI,FR,GF,PF,GA,GM,GE,DE,GH,GI,GR,GL,GD,GP,GT,GG,GN,GW,GY,HT,HN,HK,HU,IS,IN,ID,IE,IM,IL,IT,JM,JP,JE,JO,KZ,KE,KI,XK,KW,KG,LA,LV,LB,LS,LR,LI,LT,LU,MO,MG,MW,MY,MV,ML,MT,MQ,MR,MU,YT,MX,MD,MC,MN,ME,MS,MA,MZ,MM,NA,NR,NP,NL,NC,NZ,NI,NE,NG,NU,NF,MK,NO,OM,PK,PS,PA,PG,PY,PE,PH,PN,PL,PT,QA,RE,RO,RW,WS,SM,ST,SA,SN,RS,SC,SL,SG,SX,SK,SI,SB,ZA,KR,ES,LK,BL,SH,KN,LC,MF,PM,VC,SR,SE,CH,TW,TZ,TH,TL,TG,TK,TO,TT,TN,TR,TC,TV,UG,UA,AE,GB,US,UY,UZ,VU,VA,VN,VG,WF,EH,ZM,ZW'.split(',');
  var PROVINCE_REQUIRED_COUNTRY_CODES = 'AU,CA,US'.split(',');
  var FALLBACK_REGION_NAMES = {
    GB: 'United Kingdom',
    US: 'United States',
    AE: 'United Arab Emirates',
    HK: 'Hong Kong',
    KR: 'South Korea',
    XK: 'Kosovo'
  };
  var DIAL_CODE_BY_COUNTRY = {
    AF: '+93',
    AX: '+358',
    AL: '+355',
    DZ: '+213',
    AD: '+376',
    AO: '+244',
    AI: '+1',
    AG: '+1',
    AR: '+54',
    AM: '+374',
    AW: '+297',
    AU: '+61',
    AT: '+43',
    AZ: '+994',
    BS: '+1',
    BH: '+973',
    BD: '+880',
    BB: '+1',
    BY: '+375',
    BE: '+32',
    BZ: '+501',
    BJ: '+229',
    BM: '+1',
    BT: '+975',
    BO: '+591',
    BA: '+387',
    BW: '+267',
    BR: '+55',
    IO: '+246',
    BN: '+673',
    BG: '+359',
    BF: '+226',
    BI: '+257',
    CV: '+238',
    KH: '+855',
    CM: '+237',
    CA: '+1',
    KY: '+1',
    CF: '+236',
    TD: '+235',
    CL: '+56',
    CN: '+86',
    CX: '+61',
    CC: '+61',
    CO: '+57',
    KM: '+269',
    CG: '+242',
    CD: '+243',
    CK: '+682',
    CR: '+506',
    HR: '+385',
    CW: '+599',
    CY: '+357',
    CZ: '+420',
    CI: '+225',
    DK: '+45',
    DJ: '+253',
    DM: '+1',
    DO: '+1',
    EC: '+593',
    EG: '+20',
    SV: '+503',
    GQ: '+240',
    ER: '+291',
    EE: '+372',
    SZ: '+268',
    ET: '+251',
    FK: '+500',
    FO: '+298',
    FJ: '+679',
    FI: '+358',
    FR: '+33',
    GF: '+594',
    PF: '+689',
    GA: '+241',
    GM: '+220',
    GE: '+995',
    DE: '+49',
    GH: '+233',
    GI: '+350',
    GR: '+30',
    GL: '+299',
    GD: '+1',
    GP: '+590',
    GT: '+502',
    GG: '+44',
    GN: '+224',
    GW: '+245',
    GY: '+592',
    HT: '+509',
    HN: '+504',
    HK: '+852',
    HU: '+36',
    IS: '+354',
    IN: '+91',
    ID: '+62',
    IE: '+353',
    IM: '+44',
    IL: '+972',
    IT: '+39',
    JM: '+1',
    JP: '+81',
    JE: '+44',
    JO: '+962',
    KZ: '+7',
    KE: '+254',
    KI: '+686',
    XK: '+383',
    KW: '+965',
    KG: '+996',
    LA: '+856',
    LV: '+371',
    LB: '+961',
    LS: '+266',
    LR: '+231',
    LI: '+423',
    LT: '+370',
    LU: '+352',
    MO: '+853',
    MG: '+261',
    MW: '+265',
    MY: '+60',
    MV: '+960',
    ML: '+223',
    MT: '+356',
    MQ: '+596',
    MR: '+222',
    MU: '+230',
    YT: '+262',
    MX: '+52',
    MD: '+373',
    MC: '+377',
    MN: '+976',
    ME: '+382',
    MS: '+1',
    MA: '+212',
    MZ: '+258',
    MM: '+95',
    NA: '+264',
    NR: '+674',
    NP: '+977',
    NL: '+31',
    NC: '+687',
    NZ: '+64',
    NI: '+505',
    NE: '+227',
    NG: '+234',
    NU: '+683',
    NF: '+672',
    MK: '+389',
    NO: '+47',
    OM: '+968',
    PK: '+92',
    PS: '+970',
    PA: '+507',
    PG: '+675',
    PY: '+595',
    PE: '+51',
    PH: '+63',
    PN: '+64',
    PL: '+48',
    PT: '+351',
    QA: '+974',
    RE: '+262',
    RO: '+40',
    RW: '+250',
    WS: '+685',
    SM: '+378',
    ST: '+239',
    SA: '+966',
    SN: '+221',
    RS: '+381',
    SC: '+248',
    SL: '+232',
    SG: '+65',
    SX: '+1',
    SK: '+421',
    SI: '+386',
    SB: '+677',
    ZA: '+27',
    KR: '+82',
    ES: '+34',
    LK: '+94',
    BL: '+590',
    SH: '+290',
    KN: '+1',
    LC: '+1',
    MF: '+590',
    PM: '+508',
    VC: '+1',
    SR: '+597',
    SE: '+46',
    CH: '+41',
    TW: '+886',
    TZ: '+255',
    TH: '+66',
    TL: '+670',
    TG: '+228',
    TK: '+690',
    TO: '+676',
    TT: '+1',
    TN: '+216',
    TR: '+90',
    TC: '+1',
    TV: '+688',
    UG: '+256',
    UA: '+380',
    AE: '+971',
    GB: '+44',
    US: '+1',
    UY: '+598',
    UZ: '+998',
    VU: '+678',
    VA: '+39',
    VN: '+84',
    VG: '+1',
    WF: '+681',
    EH: '+212',
    ZM: '+260',
    ZW: '+263'
  };
  var countryNameToCodeCache = null;
  var PROVINCE_CODE_BY_COUNTRY = {
    AU: {
      'australian capital territory': 'ACT',
      'territorio della capitale australiana': 'ACT',
      'territoire de la capitale australienne': 'ACT',
      'australisches hauptstadtterritorium': 'ACT',
      'new south wales': 'NSW',
      'nuovo galles del sud': 'NSW',
      'nouvelle galles du sud': 'NSW',
      'neusudwales': 'NSW',
      'northern territory': 'NT',
      'territorio del nord': 'NT',
      'territoire du nord': 'NT',
      nordterritorium: 'NT',
      queensland: 'QLD',
      'south australia': 'SA',
      'australia meridionale': 'SA',
      'australie meridionale': 'SA',
      sudaustralien: 'SA',
      tasmania: 'TAS',
      tasmanie: 'TAS',
      victoria: 'VIC',
      'western australia': 'WA',
      'australia occidentale': 'WA',
      'australie occidentale': 'WA',
      westaustralien: 'WA'
    },
    CA: {
      alberta: 'AB',
      'british columbia': 'BC',
      'columbia britannica': 'BC',
      'colombie britannique': 'BC',
      'britisch kolumbien': 'BC',
      manitoba: 'MB',
      'new brunswick': 'NB',
      'nuovo brunswick': 'NB',
      'nouveau brunswick': 'NB',
      neubraunschweig: 'NB',
      'newfoundland and labrador': 'NL',
      'terranova e labrador': 'NL',
      'terre neuve et labrador': 'NL',
      'neufundland und labrador': 'NL',
      'northwest territories': 'NT',
      'territori del nord ovest': 'NT',
      'territoires du nord ouest': 'NT',
      nordwestterritorien: 'NT',
      'nova scotia': 'NS',
      'nuova scozia': 'NS',
      'nouvelle ecosse': 'NS',
      neuschottland: 'NS',
      nunavut: 'NU',
      ontario: 'ON',
      'prince edward island': 'PE',
      'isola del principe edoardo': 'PE',
      'ile du prince edouard': 'PE',
      'prinz edward insel': 'PE',
      quebec: 'QC',
      saskatchewan: 'SK',
      yukon: 'YT'
    },
    US: {
      alabama: 'AL',
      alaska: 'AK',
      'american samoa': 'AS',
      arizona: 'AZ',
      arkansas: 'AR',
      'armed forces americas': 'AA',
      'armed forces europe': 'AE',
      'armed forces pacific': 'AP',
      california: 'CA',
      colorado: 'CO',
      connecticut: 'CT',
      delaware: 'DE',
      'district of columbia': 'DC',
      'district de columbia': 'DC',
      'distretto di columbia': 'DC',
      'distrikt columbia': 'DC',
      florida: 'FL',
      'federated states of micronesia': 'FM',
      georgia: 'GA',
      guam: 'GU',
      hawaii: 'HI',
      idaho: 'ID',
      illinois: 'IL',
      indiana: 'IN',
      iowa: 'IA',
      kansas: 'KS',
      kentucky: 'KY',
      louisiana: 'LA',
      maine: 'ME',
      maryland: 'MD',
      'marshall islands': 'MH',
      massachusetts: 'MA',
      michigan: 'MI',
      micronesia: 'FM',
      minnesota: 'MN',
      mississippi: 'MS',
      missouri: 'MO',
      montana: 'MT',
      nebraska: 'NE',
      nevada: 'NV',
      'new hampshire': 'NH',
      'new jersey': 'NJ',
      'new mexico': 'NM',
      'new mexiko': 'NM',
      'nouveau mexique': 'NM',
      'nuovo messico': 'NM',
      'new york': 'NY',
      'northern mariana islands': 'MP',
      'north carolina': 'NC',
      'caroline du nord': 'NC',
      'carolina del nord': 'NC',
      nordcarolina: 'NC',
      'north dakota': 'ND',
      'dakota del nord': 'ND',
      'dakota du nord': 'ND',
      norddakota: 'ND',
      ohio: 'OH',
      oklahoma: 'OK',
      oregon: 'OR',
      palau: 'PW',
      pennsylvania: 'PA',
      'puerto rico': 'PR',
      'rhode island': 'RI',
      'south carolina': 'SC',
      'caroline du sud': 'SC',
      'carolina del sud': 'SC',
      sudcarolina: 'SC',
      'south dakota': 'SD',
      'dakota del sud': 'SD',
      'dakota du sud': 'SD',
      suddakota: 'SD',
      tennessee: 'TN',
      texas: 'TX',
      utah: 'UT',
      vermont: 'VT',
      virginia: 'VA',
      'virgin islands': 'VI',
      washington: 'WA',
      'west virginia': 'WV',
      'virginia occidentale': 'WV',
      'virginie occidentale': 'WV',
      westvirginia: 'WV',
      wisconsin: 'WI',
      wyoming: 'WY'
    }
  };

  var getField = function (formData, name) {
    return String(formData.get(name) || '').trim();
  };

  var joinName = function (firstName, lastName, fallbackName) {
    var name = [firstName, lastName].filter(Boolean).join(' ').trim();
    return name || String(fallbackName || '').trim();
  };

  var syncFullNameFields = function (form) {
    var firstName = (form.querySelector('[name="contact[First name]"]') || {}).value || '';
    var lastName = (form.querySelector('[name="contact[Last name]"]') || {}).value || '';
    var fullName = form.querySelector('[data-full-name-field]');
    if (fullName) fullName.value = joinName(firstName.trim(), lastName.trim(), fullName.value);

    var billingFirstName = (form.querySelector('[name="contact[Billing first name]"]') || {}).value || '';
    var billingLastName = (form.querySelector('[name="contact[Billing last name]"]') || {}).value || '';
    var billingFullName = form.querySelector('[data-billing-full-name-field]');
    if (billingFullName) {
      billingFullName.value = joinName(billingFirstName.trim(), billingLastName.trim(), billingFullName.value);
    }
  };

  var getRequestId = function (input) {
    var existing = input && input.value ? input.value.trim() : '';
    if (existing) return existing;

    var stored = '';
    try {
      stored = window.sessionStorage.getItem(REQUEST_STORAGE_KEY) || '';
    } catch (error) {
      stored = '';
    }

    var requestId = stored || buildRequestId();
    if (input) input.value = requestId;
    try {
      window.sessionStorage.setItem(REQUEST_STORAGE_KEY, requestId);
    } catch (error) {
      return requestId;
    }
    return requestId;
  };

  var buildRequestId = function () {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return 'sqr-' + window.crypto.randomUUID();
    }
    return 'sqr-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  };

  var parseCart = function (container) {
    var script = container.querySelector('[data-shipping-quote-cart]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent || '[]');
    } catch (error) {
      return [];
    }
  };

  var buildPayload = function (container, form, turnstileToken) {
    syncCountrySelects(container);
    syncFullNameFields(form);
    var formData = new FormData(form);
    var billingSameAsShipping = getField(formData, 'contact[Billing address same as shipping]') !== 'No';
    var requestInput = form.querySelector('[data-shipping-quote-request-id]');
    var firstName = getField(formData, 'contact[First name]');
    var lastName = getField(formData, 'contact[Last name]');
    var fullName = joinName(firstName, lastName, getField(formData, 'contact[name]'));
    var billingFirstName = getField(formData, 'contact[Billing first name]');
    var billingLastName = getField(formData, 'contact[Billing last name]');
    var billingFullName = joinName(billingFirstName, billingLastName, getField(formData, 'contact[Billing full name]'));

    return {
      schemaVersion: 1,
      requestId: getRequestId(requestInput),
      turnstileToken: turnstileToken,
      locale: getField(formData, 'contact[Locale]'),
      market: getField(formData, 'contact[Market]'),
      cartTotal: getField(formData, 'contact[Cart total]'),
      currency: getField(formData, 'contact[Currency]'),
      pageUrl: window.location.href,
      billingSameAsShipping: billingSameAsShipping,
      newsletterOptIn: false,
      notes: getField(formData, 'contact[Notes]'),
      contact: {
        firstName: firstName,
        lastName: lastName,
        name: fullName,
        email: getField(formData, 'contact[email]'),
        phone: getField(formData, 'contact[phone]'),
        company: getField(formData, 'contact[Company]')
      },
      shippingAddress: {
        firstName: firstName,
        lastName: lastName,
        name: fullName,
        company: getField(formData, 'contact[Company]'),
        address1: getField(formData, 'contact[Address line 1]'),
        address2: getField(formData, 'contact[Address line 2]'),
        city: getField(formData, 'contact[City]'),
        province: getField(formData, 'contact[State/Province]'),
        provinceCode: getField(formData, 'contact[State/Province code]'),
        zip: getField(formData, 'contact[Postal code]'),
        country: getField(formData, 'contact[Destination country]'),
        countryCode: getField(formData, 'contact[Destination country code]')
      },
      billingAddress: {
        firstName: billingFirstName,
        lastName: billingLastName,
        name: billingFullName,
        company: getField(formData, 'contact[Billing company]'),
        address1: getField(formData, 'contact[Billing address line 1]'),
        address2: getField(formData, 'contact[Billing address line 2]'),
        city: getField(formData, 'contact[Billing City]'),
        province: getField(formData, 'contact[Billing State/Province]'),
        provinceCode: getField(formData, 'contact[Billing State/Province code]'),
        zip: getField(formData, 'contact[Billing Postal code]'),
        country: getField(formData, 'contact[Billing country]'),
        countryCode: getField(formData, 'contact[Billing country code]')
      },
      cart: parseCart(container)
    };
  };

  var setSubmitting = function (form, isSubmitting) {
    var button = form.querySelector('[type="submit"]');
    if (button) {
      button.disabled = isSubmitting;
      button.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    }
  };

  var showResponse = function (container, type, message) {
    var existing = container.querySelector('[data-shipping-quote-response]');
    if (existing) existing.remove();

    var element = document.createElement('div');
    element.className = type === 'success' ? 'hdt-form-success hdt-form-response' : 'hdt-form-error hdt-form-response';
    element.setAttribute('data-shipping-quote-response', '');
    element.setAttribute('role', type === 'success' ? 'status' : 'alert');
    var paragraph = document.createElement('p');
    paragraph.textContent = decodeHtml(message);
    element.appendChild(paragraph);

    var form = container.querySelector('form');
    if (form) form.appendChild(element);
  };

  var clearFieldErrors = function (form) {
    var fields = form.querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i += 1) {
      fields[i].setCustomValidity('');
    }
  };

  var visibleProvinceControl = function (field) {
    if (!field) return null;
    var select = field.id ? document.getElementById(field.id + '-Select') : null;
    return select && !select.hidden && !select.disabled ? select : field;
  };

  var getErrorField = function (form, errorCode) {
    var selectorByError = {
      invalid_email: '[name="contact[email]"]',
      missing_first_name: '[name="contact[First name]"]',
      missing_last_name: '[name="contact[Last name]"]',
      invalid_phone: '[name="contact[phone]"]',
      missing_shipping_address: '[name="contact[Address line 1]"]',
      missing_shipping_country_code: '[data-shipping-country-select]',
      missing_billing_address: '[name="contact[Billing address line 1]"]',
      missing_billing_country_code: '[name="contact[Billing country]"]'
    };

    if (errorCode === 'missing_shipping_province') {
      return visibleProvinceControl(form.querySelector('[name="contact[State/Province]"]'));
    }
    if (errorCode === 'missing_billing_province') {
      return visibleProvinceControl(form.querySelector('[name="contact[Billing State/Province]"]'));
    }

    return selectorByError[errorCode] ? form.querySelector(selectorByError[errorCode]) : null;
  };

  var errorMessageForCode = function (container, errorCode, fallback) {
    if (TURNSTILE_ERROR_CODES[errorCode]) {
      return decodeHtml(container.getAttribute('data-turnstile-error-message') || 'Please complete the security check and try again.');
    }
    var attribute = 'data-error-' + String(errorCode || '').replace(/_/g, '-');
    return decodeHtml(container.getAttribute(attribute) || fallback || container.getAttribute('data-error-message') || 'Unable to submit the request.');
  };

  var errorMessageForError = function (container, error) {
    var errorCode = error && error.body ? error.body.error : '';
    return errorMessageForCode(container, errorCode, error && error.message);
  };

  var applyServerValidationError = function (container, form, error) {
    var errorCode = error && error.body ? error.body.error : '';
    if (!errorCode) return false;

    var message = errorMessageForCode(container, errorCode, error.message);
    var field = getErrorField(form, errorCode);
    if (!field) return false;

    field.setCustomValidity(message);
    field.reportValidity();
    field.focus({ preventScroll: false });
    return true;
  };

  var clearRequestId = function (form) {
    try {
      window.sessionStorage.removeItem(REQUEST_STORAGE_KEY);
    } catch (error) {
      // The hidden field still needs clearing when storage is unavailable.
    }
    var requestInput = form ? form.querySelector('[data-shipping-quote-request-id]') : null;
    if (requestInput) {
      requestInput.value = '';
      requestInput.defaultValue = '';
    }
  };

  var isAcceptedResponse = function (response, body, requestId) {
    return Boolean(
      response &&
      response.status === 202 &&
      body &&
      body.accepted === true &&
      typeof body.requestId === 'string' &&
      REQUEST_ID_PATTERN.test(body.requestId) &&
      body.requestId === requestId
    );
  };

  var submitPayload = function (endpoint, payload, fetchImpl) {
    var request = fetchImpl || window.fetch || fetch;
    return request(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().catch(function () {
        return {};
      }).then(function (body) {
        if (!isAcceptedResponse(response, body, payload.requestId)) {
          var error = new Error(body.message || body.error || 'Request failed');
          error.body = body;
          throw error;
        }
        return body;
      });
    });
  };

  var runSubmission = function (options) {
    return submitPayload(options.endpoint, options.payload, options.fetchImpl)
      .then(options.onSuccess)
      .catch(options.onError)
      .finally(options.onSettled);
  };

  var normalizeCountryName = function (value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/gi, ' ')
      .trim()
      .toLowerCase();
  };

  var getCountryNameToCode = function () {
    if (countryNameToCodeCache) return countryNameToCodeCache;

    var map = {};
    var htmlLang = document.documentElement.lang || navigator.language || 'en';
    var locales = ['en', htmlLang, htmlLang.split('-')[0], 'it', 'fr', 'de'];

    for (var i = 0; i < REGION_CODES.length; i += 1) {
      var code = REGION_CODES[i];
      map[normalizeCountryName(code)] = code;
      if (FALLBACK_REGION_NAMES[code]) {
        map[normalizeCountryName(FALLBACK_REGION_NAMES[code])] = code;
      }

      for (var j = 0; j < locales.length; j += 1) {
        try {
          var displayNames = new Intl.DisplayNames([locales[j]], { type: 'region' });
          var name = displayNames.of(code);
          if (name) map[normalizeCountryName(name)] = code;
        } catch (error) {
          break;
        }
      }
    }

    countryNameToCodeCache = map;
    return map;
  };

  var countryCodeFromOption = function (option) {
    if (!option) return '';
    var value = String(option.value || '').trim();
    if (/^[A-Z]{2}$/i.test(value)) return value.toUpperCase();
    return getCountryNameToCode()[normalizeCountryName(value)] || getCountryNameToCode()[normalizeCountryName(option.textContent)] || '';
  };

  var selectedCountryCode = function (select) {
    return select ? countryCodeFromOption(select.options[select.selectedIndex]) : '';
  };

  var provinceCodeFromValue = function (value, countryCode) {
    var raw = String(value || '').trim();
    if (!raw) return '';
    var code = raw.toUpperCase();
    var countryMap = PROVINCE_CODE_BY_COUNTRY[String(countryCode || '').toUpperCase()] || {};

    for (var key in countryMap) {
      if (Object.prototype.hasOwnProperty.call(countryMap, key) && countryMap[key] === code) {
        return code;
      }
    }

    return countryMap[normalizeCountryName(raw)] || '';
  };

  var syncCountrySelect = function (select) {
    var targetId = select.getAttribute('data-country-code-target');
    var input = targetId ? document.getElementById(targetId) : null;
    if (!input) return;

    if (!select.value) {
      var defaultCode = String(select.getAttribute('data-default-country-code') || input.value || '').trim().toUpperCase();
      if (defaultCode) {
        for (var i = 0; i < select.options.length; i += 1) {
          if (countryCodeFromOption(select.options[i]) === defaultCode) {
            select.selectedIndex = i;
            break;
          }
        }
      }
    }

    input.value = countryCodeFromOption(select.options[select.selectedIndex]) || input.value;
  };

  var syncCountrySelects = function (container) {
    var selects = container.querySelectorAll('[data-country-select]');
    for (var i = 0; i < selects.length; i += 1) {
      syncCountrySelect(selects[i]);
    }
  };

  var parseCountryProvinces = function (select) {
    if (!select || select.selectedIndex < 0) return [];
    var countryCode = selectedCountryCode(select);
    var option = select.options[select.selectedIndex];
    var raw = option ? option.getAttribute('data-provinces') : '';
    if (!raw) return [];

    try {
      return JSON.parse(decodeHtml(raw)).map(function (province) {
        var name = '';
        var rawCode = '';
        if (Array.isArray(province)) {
          name = String(province[0] || '');
          rawCode = String(province[1] || province[0] || '');
        } else {
          name = String(province.name || province.translatedName || province.code || '');
          rawCode = String(province.code || province.name || '');
        }
        return {
          name: name,
          code: provinceCodeFromValue(rawCode, countryCode) || provinceCodeFromValue(name, countryCode) || rawCode
        };
      }).filter(function (province) {
        return province.name && province.code;
      });
    } catch (error) {
      return [];
    }
  };

  var ensureProvinceSelect = function (field) {
    var id = field.id ? field.id + '-Select' : '';
    var select = id ? document.getElementById(id) : null;
    if (select) return select;

    select = document.createElement('select');
    select.id = id;
    select.className = field.className;
    select.setAttribute('data-province-select', '');
    select.setAttribute('data-province-select-for', field.id || '');
    select.hidden = true;
    select.disabled = true;
    select.addEventListener('change', function () {
      syncProvinceField(field, select);
    });
    field.insertAdjacentElement('afterend', select);
    return select;
  };

  var syncProvinceSelectOptions = function (select, provinces, placeholder, currentValue, currentCode) {
    var selectedValue = String(currentValue || '').trim();
    var selectedCode = String(currentCode || '').trim();
    select.innerHTML = '';

    var placeholderOption = document.createElement('option');
    placeholderOption.value = '';
    placeholderOption.textContent = placeholder;
    select.appendChild(placeholderOption);

    provinces.forEach(function (province) {
      var option = document.createElement('option');
      option.value = province.code;
      option.textContent = province.name;
      option.setAttribute('data-province-name', province.name);
      if (
        (selectedCode && selectedCode.toUpperCase() === province.code.toUpperCase()) ||
        (selectedValue &&
          (selectedValue.toUpperCase() === province.code.toUpperCase() ||
          normalizeCountryName(selectedValue) === normalizeCountryName(province.name))
        )
      ) {
        option.selected = true;
      }
      select.appendChild(option);
    });
  };

  var getProvinceCodeInput = function (field) {
    var targetId = field.getAttribute('data-province-code-target');
    return targetId ? document.getElementById(targetId) : null;
  };

  var selectedProvinceCode = function (field, countryCode) {
    var codeInput = getProvinceCodeInput(field);
    return (codeInput && codeInput.value) || provinceCodeFromValue(field.value, countryCode);
  };

  var syncProvinceField = function (field, select) {
    var codeInput = getProvinceCodeInput(field);
    var option = select && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
    var code = option ? String(option.value || '').trim() : provinceCodeFromValue(field.value, '');
    field.value = code || field.value;
    if (codeInput) codeInput.value = code;
  };

  var syncTypedProvinceCode = function (field) {
    var selector = field.getAttribute('data-province-country-selector');
    var countrySelect = selector ? document.querySelector(selector) : null;
    var countryCode = selectedCountryCode(countrySelect);
    var codeInput = getProvinceCodeInput(field);
    if (codeInput) codeInput.value = provinceCodeFromValue(field.value, countryCode);
  };

  var getSelectedCountryName = function (select) {
    if (!select || select.selectedIndex < 0) return '';
    var option = select.options[select.selectedIndex];
    return String(option ? option.textContent || option.value : '').trim();
  };

  var getStandardCountryCodes = function (notice) {
    return String(notice.getAttribute('data-standard-country-codes') || '')
      .split(',')
      .map(function (code) {
        return code.trim().toUpperCase();
      })
      .filter(Boolean);
  };

  var decodeHtml = function (value) {
    var decoded = String(value || '');
    var textarea = document.createElement('textarea');
    for (var i = 0; i < 3; i += 1) {
      textarea.innerHTML = decoded;
      if (textarea.value === decoded) break;
      decoded = textarea.value;
    }
    return decoded;
  };

  var getStandardNoticeTemplate = function (scope) {
    var template = scope.querySelector('[data-standard-shipping-notice-template]');
    if (template && template.content) {
      return decodeHtml(template.content.textContent || '');
    }
    return '';
  };

  var applyDialCodeToPlaceholder = function (placeholder, dialCode) {
    if (!placeholder || !dialCode) return placeholder;
    if (/\+\d[\d\s-]*/.test(placeholder)) {
      return placeholder.replace(/\+\d[\d\s-]*/, dialCode);
    }
    return placeholder + ' (' + dialCode + ')';
  };

  var syncPhoneSuggestion = function (container) {
    var phoneField = container.querySelector('[name="contact[phone]"]');
    var countrySelect = container.querySelector('[data-shipping-country-select]');
    if (!phoneField || !countrySelect) return;

    var countryCode = selectedCountryCode(countrySelect);
    var dialCode = DIAL_CODE_BY_COUNTRY[countryCode] || '';
    var basePlaceholder = phoneField.getAttribute('data-base-placeholder') || phoneField.getAttribute('placeholder') || '';
    if (!phoneField.getAttribute('data-base-placeholder')) {
      phoneField.setAttribute('data-base-placeholder', basePlaceholder);
    }

    if (dialCode) {
      phoneField.placeholder = applyDialCodeToPlaceholder(basePlaceholder, dialCode);
    }

    var previousDialCode = phoneField.getAttribute('data-current-dial-code') || '';
    var currentValue = phoneField.value.trim();
    if (!currentValue || (previousDialCode && currentValue === previousDialCode)) {
      phoneField.value = dialCode ? dialCode + ' ' : '';
    }
    phoneField.setAttribute('data-current-dial-code', dialCode);
  };

  var updateProvinceRequirements = function (container) {
    var fields = container.querySelectorAll('[data-province-field]');
    for (var i = 0; i < fields.length; i += 1) {
      var field = fields[i];
      var selector = field.getAttribute('data-province-country-selector');
      var countrySelect = selector ? document.querySelector(selector) : null;
      var countryCode = selectedCountryCode(countrySelect);
      var provinces = parseCountryProvinces(countrySelect);
      var isRequired = PROVINCE_REQUIRED_COUNTRY_CODES.indexOf(countryCode) !== -1;
      var defaultPlaceholder = field.getAttribute('data-province-default-placeholder') || field.getAttribute('placeholder') || '';
      var requiredPlaceholder = field.getAttribute('data-province-required-placeholder') || defaultPlaceholder;
      var provinceSelect = ensureProvinceSelect(field);
      var provinceCodeInput = getProvinceCodeInput(field);
      var currentProvinceCode = selectedProvinceCode(field, countryCode);

      if (provinces.length > 0) {
        syncProvinceSelectOptions(provinceSelect, provinces, requiredPlaceholder, field.value, currentProvinceCode);
        field.hidden = true;
        field.required = false;
        field.setAttribute('aria-hidden', 'true');
        provinceSelect.hidden = false;
        provinceSelect.disabled = field.disabled;
        provinceSelect.required = isRequired && !field.disabled;
        if (provinceSelect.value) {
          field.value = provinceSelect.value;
          if (provinceCodeInput) provinceCodeInput.value = provinceSelect.value;
        } else if (provinceCodeInput) {
          provinceCodeInput.value = '';
        }
      } else {
        provinceSelect.hidden = true;
        provinceSelect.disabled = true;
        provinceSelect.required = false;
        field.hidden = false;
        field.removeAttribute('aria-hidden');
        field.required = isRequired && !field.disabled;
        if (provinceCodeInput) provinceCodeInput.value = provinceCodeFromValue(field.value, countryCode);
      }

      field.placeholder = isRequired ? requiredPlaceholder : defaultPlaceholder;
    }
  };

  var updateStandardShippingNotice = function (container) {
    var state = runtime.containerStates.get(container);
    var scope = container.closest('.hdt-page-cart__content') || container;
    var notice = scope.querySelector('[data-standard-shipping-notice]');
    var noticeText = scope.querySelector('[data-standard-shipping-notice-text]');
    var shippingCountrySelect = container.querySelector('[data-shipping-country-select]');
    var submitButton = container.querySelector('[data-shipping-quote-submit]');
    var isStandardCountry = false;

    if (notice && noticeText && shippingCountrySelect) {
      var countryCode = countryCodeFromOption(shippingCountrySelect.options[shippingCountrySelect.selectedIndex]);
      var countryName = getSelectedCountryName(shippingCountrySelect);
      isStandardCountry = getStandardCountryCodes(notice).indexOf(countryCode) !== -1;

      if (!countryName || !isStandardCountry) {
        notice.hidden = true;
      } else {
        var template = getStandardNoticeTemplate(scope);
        noticeText.textContent = template ? template.replace('%%COUNTRY%%', countryName) : countryName;
        notice.hidden = false;
      }
    }

    var continueButton = scope.querySelector('[data-standard-shipping-continue]');
    var destinationField = scope.querySelector('[data-standard-shipping-country]');
    var destinationReturn = scope.querySelector('.hdt-quote-destination-form [name="return_to"]');
    if (continueButton && destinationField && destinationReturn) {
      var selectedCode = shippingCountrySelect ? selectedCountryCode(shippingCountrySelect) : '';
      var availableOption = document.querySelector('[data-localization-country] option[value="' + selectedCode + '"]');
      var canContinue = isStandardCountry && Boolean(availableOption);
      continueButton.disabled = !canContinue;
      continueButton.form.hidden = !canContinue;
      destinationField.value = canContinue ? selectedCode : '';
      if (canContinue) {
        continueButton.textContent = continueButton.getAttribute('data-label-template').replace('%%COUNTRY%%', getSelectedCountryName(shippingCountrySelect));
        var countryLanguages = (availableOption.getAttribute('data-country-languages') || '').split(',');
        var languageField = continueButton.form.querySelector('[name="language_code"]');
        if (languageField && countryLanguages.indexOf(languageField.value) === -1 && countryLanguages[0]) languageField.value = countryLanguages[0];
        destinationReturn.value = continueButton.form.getAttribute('data-return-path') + '?hdt_checkout_country=' + encodeURIComponent(selectedCode);
      }
    }

    if (submitButton) {
      submitButton.disabled = !state || !state.controllerReady || state.isSubmitting || isStandardCountry;
    }
  };

  var isConnected = function (container) {
    return !container || container.isConnected !== false;
  };

  var pruneTurnstileCallbacks = function () {
    runtime.turnstile.callbacks = runtime.turnstile.callbacks.filter(function (entry) {
      return isConnected(entry.container);
    });
  };

  var getTurnstileScript = function () {
    var scripts = document.querySelectorAll('[data-shipping-quote-turnstile-script]');
    for (var i = 0; i < scripts.length; i += 1) {
      if (!runtime.turnstile.failedScripts.has(scripts[i])) return scripts[i];
    }
    return null;
  };

  var settleTurnstileScript = function (script, onLoad, onError, didLoad) {
    script.removeEventListener('load', onLoad);
    script.removeEventListener('error', onError);
    if (runtime.turnstile.script === script) {
      runtime.turnstile.listening = false;
      runtime.turnstile.script = null;
    }

    pruneTurnstileCallbacks();
    if (!didLoad) {
      runtime.turnstile.failedScripts.add(script);
      return;
    }

    var entries = runtime.turnstile.callbacks.splice(0);
    for (var i = 0; i < entries.length; i += 1) {
      try {
        entries[i].callback();
      } catch (error) {
        continue;
      }
    }
  };

  var attachTurnstileScript = function () {
    if (runtime.turnstile.listening) return;

    var script = getTurnstileScript();
    if (!script) return;

    var onLoad = function () {
      settleTurnstileScript(script, onLoad, onError, true);
    };
    var onError = function () {
      settleTurnstileScript(script, onLoad, onError, false);
    };

    runtime.turnstile.listening = true;
    runtime.turnstile.script = script;
    script.addEventListener('load', onLoad);
    script.addEventListener('error', onError);
  };

  var whenTurnstileReady = function (container, callback) {
    if (!isConnected(container)) return;
    if (window.turnstile) {
      try {
        callback();
      } catch (error) {
        return;
      }
      return;
    }

    pruneTurnstileCallbacks();
    runtime.turnstile.callbacks.push({ container: container, callback: callback });
    attachTurnstileScript();
  };

  var init = function (container) {
    if (runtime.containerStates.has(container)) return;

    var state = {
      controllerReady: false,
      isSubmitting: false,
      token: '',
      widgetId: null
    };
    runtime.containerStates.set(container, state);

    var endpoint = String(container.getAttribute('data-intake-endpoint') || '').trim();
    var sitekey = String(container.getAttribute('data-turnstile-site-key') || '').trim();
    var form = container.querySelector('form');
    var submitButton = form ? form.querySelector('[data-shipping-quote-submit]') : null;
    if (!form || !submitButton || !endpoint || !sitekey) return;

    var renderTurnstile = function () {
      var target = container.querySelector('[data-shipping-quote-turnstile]');
      if (!target || !window.turnstile || state.widgetId !== null) return;
      state.widgetId = window.turnstile.render(target, {
        sitekey: sitekey,
        action: 'shipping_quote',
        callback: function (token) { state.token = token; },
        'expired-callback': function () { state.token = ''; },
        'error-callback': function () { state.token = ''; }
      });
    };

    var resetTurnstile = function () {
      state.token = '';
      if (
        state.widgetId !== null &&
        window.turnstile &&
        typeof window.turnstile.reset === 'function'
      ) {
        window.turnstile.reset(state.widgetId);
      }
    };

    whenTurnstileReady(container, renderTurnstile);
    syncCountrySelects(container);
    syncPhoneSuggestion(container);
    updateProvinceRequirements(container);
    updateStandardShippingNotice(container);

    var countrySelects = container.querySelectorAll('[data-country-select]');
    for (var i = 0; i < countrySelects.length; i += 1) {
      countrySelects[i].addEventListener('change', function (event) {
        syncCountrySelect(event.currentTarget);
        syncPhoneSuggestion(container);
        updateProvinceRequirements(container);
        updateStandardShippingNotice(container);
      });
    }

    var provinceFields = container.querySelectorAll('[data-province-field]');
    for (var k = 0; k < provinceFields.length; k += 1) {
      provinceFields[k].addEventListener('input', function (event) {
        syncTypedProvinceCode(event.currentTarget);
      });
      provinceFields[k].addEventListener('change', function (event) {
        syncTypedProvinceCode(event.currentTarget);
      });
    }

    var billingSameToggle = container.querySelector('[data-billing-same-toggle]');
    if (billingSameToggle) {
      billingSameToggle.addEventListener('change', function () {
        updateProvinceRequirements(container);
      });
    }

    var fields = form.querySelectorAll('input, select, textarea');
    for (var j = 0; j < fields.length; j += 1) {
      fields[j].addEventListener('input', function (event) {
        event.currentTarget.setCustomValidity('');
      });
      fields[j].addEventListener('change', function (event) {
        event.currentTarget.setCustomValidity('');
      });
    }

    var handleSubmit = function (event) {
      event.preventDefault();
      clearFieldErrors(form);
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      if (!state.token) {
        showResponse(
          container,
          'error',
          container.getAttribute('data-turnstile-error-message') || 'Please complete the security check and try again.'
        );
        return;
      }

      var payload = buildPayload(container, form, state.token);
      state.isSubmitting = true;
      setSubmitting(form, true);
      runSubmission({
        endpoint: endpoint,
        payload: payload,
        onSuccess: function (body) {
          publishAnalyticsEvent('shipping_quote_request', {
            form_context: 'shipping_quote',
            destination_country: payload.shippingAddress.countryCode,
            cart_item_count: analyticsCartItemCount(payload.cart)
          });
          clearRequestId(form);
          var label = container.getAttribute('data-request-id-label') || 'Request ID';
          showResponse(container, 'success', decodeHtml(container.getAttribute('data-success-message') || 'Thank you.') + ' ' + decodeHtml(label) + ': ' + body.requestId);
          form.reset();
          syncCountrySelects(container);
          syncPhoneSuggestion(container);
          updateProvinceRequirements(container);
          updateStandardShippingNotice(container);
        },
        onError: function (error) {
          publishAnalyticsEvent('shipping_quote_error', {
            form_context: 'shipping_quote',
            error_code: analyticsErrorCode(error)
          });
          if (applyServerValidationError(container, form, error)) return;
          showResponse(
            container,
            'error',
            errorMessageForError(container, error)
          );
        },
        onSettled: function () {
          resetTurnstile();
          state.isSubmitting = false;
          setSubmitting(form, false);
          updateStandardShippingNotice(container);
        }
      });
    };

    form.addEventListener('submit', handleSubmit);
    state.controllerReady = true;
    container.setAttribute('data-shipping-quote-controller-ready', 'true');
    form.removeAttribute('inert');
    form.removeAttribute('onsubmit');
    updateStandardShippingNotice(container);
  };

  var initScope = function (root) {
    if (!root) return;
    if (root.matches && root.matches(SELECTOR)) init(root);
    if (!root.querySelectorAll) return;

    var containers = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < containers.length; i += 1) {
      init(containers[i]);
    }
  };

  runtime.errorMessageForError = errorMessageForError;
  runtime.initScope = initScope;
  runtime.runSubmission = runSubmission;

  if (!runtime.sectionLoadBound) {
    document.addEventListener('shopify:section:load', function (event) {
      initScope(event.target);
    });
    runtime.sectionLoadBound = true;
  }

  initScope(document);
})();
